<template>
  <div class="tracks-table text-gray-700">
    <slot />
  </div>
</template>

<script>

export default {};

</script>

<style lang="scss">

.tracks-table {

  &__head {

  }

  &__row {
    @apply flex;
    @apply items-center;
    @apply py-3;
    @apply px-10;
  }

  &__records {
    @apply border-b-2;
    @apply border-gray-200;
  }


  &__avatar-cell {
    width: 100%;
    max-width: 5rem;
    @apply flex-shrink-0;
  }

  &__artists-cell {
    flex: 3;
  }

   &__album-cell {
    flex: 4;
    display: none;
    @screen sm {
      display: initial;
    }
  }

  &__time-cell {
    flex: 1;
    display: none;
    @screen sm {
      display: initial;
    }
  }

  &__player {
    display: none;
    @screen md {
      display: initial;
    }
  }

  &__controls-cell {
    @screen md {
      flex: 2;
    }
  }

}

</style>
